import cn from 'clsx'
import * as React from 'react'
import { FaCog as CogIcon } from '@react-icons/all-files/fa/FaCog'

const PendingStatus = ({
  message,
  size,
}: {
  message: string
  size: string
}): React.ReactElement<'div'> => {
  const playerBarClass = cn('AudioPlayer', {
    'is-small': size === 'small',
  })
  return (
    <div className="AudioPlayer_Wrapper">
      <div className={playerBarClass}>
        <span className="AudioPlayer_Transcoding">
          <CogIcon />
        </span>
        <div className="AudioPlayer_SeekMessage">{message}</div>
      </div>
    </div>
  )
}

export default PendingStatus
